"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.everyOf = everyOf;
exports.date = date;
exports.numericString = numericString;
exports.requiredComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _airbnbPropTypes = require("airbnb-prop-types");

var _children = require("./children.js");

var _luxon = require("luxon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function everyOf() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  var validator = function validator(props) {
    var childrenArray = _react.default.Children.toArray(props.children);

    var element = childrenArray[0];

    if (element && types.includes(element.type)) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return (0, _airbnbPropTypes.childrenOfType)(element.type).apply(void 0, [props].concat(args));
    }
  };

  validator.isRequired = function (props) {
    var childrenArray = _react.default.Children.toArray(props.children);

    var element = childrenArray[0];

    if (element && types.includes(element.type)) {
      var _childrenOfType;

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return (_childrenOfType = (0, _airbnbPropTypes.childrenOfType)(element.type)).isRequired.apply(_childrenOfType, [props].concat(args));
    } else {
      throw new Error('There are no children with the specified types.');
    }
  };

  return validator;
}

function date(props, propName, componentName) {
  return _luxon.DateTime.fromISO(props[propName]).isValid || !props[propName] ? null : new Error("Invalid value for property ".concat(propName, " in component ").concat(componentName, "! It should be a String in ISO date format, but the following was provided: ").concat(props.date, "."));
}

date.isRequired = function (props, propName, componentName) {
  if (!props[propName]) {
    return new Error("".concat(propName, " in ").concat(componentName, " is required."));
  }

  return date(props, propName, componentName);
};

function numericString(props, propName, componentName) {
  var propValue = props[propName];
  var isString = typeof propValue === 'string';
  var isNumeric = !isNaN(parseFloat(propValue)) && isFinite(propValue);
  return isString && isNumeric || !props[propName] ? null : new Error("Invalid value for property ".concat(propName, " in component ").concat(componentName, "! It should be a String only with digit or float numbers, but the following was provided: ").concat(propValue, "."));
}

numericString.isRequired = function (props, propName, componentName) {
  if (!props[propName]) {
    return new Error("".concat(propName, " in ").concat(componentName, " is required."));
  }

  return numericString(props, propName, componentName);
};

var requiredComponent = function requiredComponent(_requiredComponent) {
  return function (props, propName, componentName) {
    if (propName === 'children') {
      if (_react.default.Children.count(props.children) === 0) {
        return Error("children. <".concat(_requiredComponent, "> is required as one of the children of ").concat(componentName, "."));
      } else {
        var hasRequiredComponent = (0, _children.getFirstDirectChildOfTypes)(props.children, [_requiredComponent]);

        if (!hasRequiredComponent) {
          return Error("children. Required <".concat(_requiredComponent, "> child is missing"));
        }
      }
    }

    return null;
  };
};

exports.requiredComponent = requiredComponent;